import React, { FC } from 'react'
import { InputNumber, InputText } from '../../../../components/input'
import { CreateNotification } from '../../../../components/notifier'

import { IInputArrayFormProps, IInputArrayDataStructureItem } from '../../../../components/input/arrayData'
import { Button } from '../../../../modules/button'
import { InputWraper, useForm } from '../../../../modules/form'
import { ObjectUtils } from '../../../../modules/utils'

export const CodeProcessContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: 'Users',
    label: 'Người sử dụng',
    isVisibleOnList: true,
  },
  {
    name: 'NameSupplies',
    label: 'Mã nhân viên',
    isVisibleOnList: true,
  },
  {
    name: 'WorkingDepartment',
    label: 'Bộ phận công tác',
    isVisibleOnList: true,
  },
  {
    name: 'Title',
    label: 'Chức danh',
    isVisibleOnList: true,
  },
  {
    name: 'Suggestions',
    label: 'Đề nghị',
    isVisibleOnList: true,
  },
  {
    name: 'SuggestionDetails',
    label: 'Chi tiết đề nghị',
    isVisibleOnList: true,
  },
  {
    name: 'DegreeTraining',
    label: 'Lý do/trình độ đào tạo',
    isVisibleOnList: true,
  },
  {
    name: 'Email',
    label: 'Email liên lạc',
    isVisibleOnList: true,
  },
  {
    name: 'PhoneNumber',
    label: 'Số điện thoại',
    isVisibleOnList: true,
  },
  
]

export const CodeProcessContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue
      }
    })),
    onSubmit: (values) => {
      if  (!values.Users ||
           !values.NameSupplies ||
           !values.WorkingDepartment ||
           !values.Suggestions ||
           !values.SuggestionDetails ||
           !values.Email ||
           !values.PhoneNumber
         )
           CreateNotification({ title: 'Thông báo', body: "Vui lòng nhập đầy đủ thông tin yêu cầu!", icon: '/icons/warning.png' });
       else
           props.onSubmit(values)      
    }
  })

  // useEffect(() => {
  //   if (employees) {
  //     if (childFormData && childFormData.staffCode) {
  //       setEmployeesSelected(employees.find((o: any) => o.eEmployeeId === childFormData.staffCode).eMail);
  //     } else {
  //       setEmployeesSelected(employees[0].eMail);
  //       setEmployeesCode(employees[0].eEmployeeId);
  //     }
  //   }
  // }, [employees])

  return (
    <div className="Form__add-new py-4">
      <h6>( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập </h6>
      <InputWraper inputProps={getInputProps('Users')} renderInput={s => <InputText
              {...s}
            />} isRequired/>

      <InputWraper inputProps={getInputProps('NameSupplies')} renderInput={s => <InputText
              {...s}
            />} isRequired/>
      <InputWraper inputProps={getInputProps('WorkingDepartment')} renderInput={s => <InputText
              {...s}
            />} isRequired/>

      <InputWraper inputProps={getInputProps('Title')} renderInput={s => <InputText
              {...s}
            />}/> 
      <InputWraper inputProps={getInputProps('Suggestions')} renderInput={s => <InputText
              {...s}
            />} isRequired/>
      <InputWraper inputProps={getInputProps('SuggestionDetails')} renderInput={s => <InputText
            {...s}
            />} isRequired/>
      <InputWraper inputProps={getInputProps('DegreeTraining')} renderInput={s => <InputText
              {...s}
            />} />
      <InputWraper inputProps={getInputProps('Email')} renderInput={s => <InputText
              {...s}
            />} isRequired/>
      <InputWraper inputProps={getInputProps('PhoneNumber')} renderInput={s => <InputNumber
              {...s}
            />}  isRequired/>   

      <div className="foot">
        <Button
          type="button"
          label="Xác nhận"
          onClick={handleSubmit}
        />
      </div>
    </div>
  )
}